<template>
  <div>
    <!-- Needs Confirmation -->
    <v-alert :value="needConfirmation" :type="confirmationActive ? 'info' : 'warning'">
      <span class="subheading" v-if="confirmationActive">
        {{ confirmationEmail }}
        has {{ confirmationExpiry | inWords }} left to confirm
      </span>
      <span class="subheading" v-else-if="confirmationExpired">
        {{ confirmationEmail }}
        confirmation has expired
      </span>
      <span class="subheading" v-else>
        {{ confirmationEmail }}
        confirmation is pending
      </span>
      <can I="edit" a="Candidate">
        <v-btn small @click="sendEmailConfirmation" class="secondary right">
          <v-icon left>mdi-email</v-icon> Resend Confirmation
        </v-btn>
        <v-btn small @click="manualConfirmation" class="secondary right">
          <v-icon left>mdi-account-check</v-icon> Manual Confirmation
        </v-btn>
      </can>
    </v-alert>

    <!-- Email Confirmed -->
    <v-alert :value="!needConfirmation" type="success">
      <span class="subheading">
        {{ confirmationEmail }}
        confirmed<span v-if="confirmedAt"> {{ confirmedAt | date('dd MMMM yyyy') }}</span>
        <v-btn small @click="manualUnconfirmation" class="error right">
          <v-icon left>mdi-account-remove</v-icon> Manually Unconfirm
        </v-btn>
      </span>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: { candidate: { type: Object, required: true } },
  computed: {
    confirmationActive() {
      return !!this.confirmationExpiry && this.confirmationExpiry > new Date()
    },
    confirmationEmail() {
      if (!this.candidate) return ''

      return this.candidate.unconfirmedEmail ? this.candidate.unconfirmedEmail : this.candidate.email
    },
    confirmationExpiry() {
      if (!this.candidate) return null
      const confirmationSentAt = this.parseDate(this.candidate.confirmationSentAt)
      if (!confirmationSentAt) return null

      const confirmationExpiry = new Date(confirmationSentAt)
      confirmationExpiry.setDate(confirmationExpiry.getDate() + 1)

      return confirmationExpiry
    },
    confirmationExpired() {
      return !!this.confirmationExpiry && this.confirmationExpiry <= new Date()
    },
    confirmedAt() {
      if (!this.candidate) return null

      return this.parseDate(this.candidate.confirmedAt)
    },
    needConfirmation() {
      return !!this.candidate && !this.candidate.confirmedAt
    },
  },
  methods: {
    parseDate(value) {
      if (!value) return null

      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? null : date
    },
    sendEmailConfirmation() {
      this.$store
        .dispatch('admin/candidates/sendEmailConfirmation', this.$route.params.id)
        .then(() => {
          this.$store.dispatch('snackbarSuccess', 'Confirmation Sent')
          setTimeout(() => this.$emit('refresh'), 10000)
        })
        .catch(() => this.$store.dispatch('snackbarError', 'Confirmation Not Sent'))
    },
    manualConfirmation() {
      this.$store
        .dispatch('admin/candidates/manualConfirmation', this.$route.params.id)
        .then(() => {
          this.$store.dispatch('snackbarSuccess', 'Email Confirmed')
          setTimeout(() => this.$emit('refresh'), 10000)
        })
        .catch(() => this.$store.dispatch('snackbarError', 'Confirmation failed'))
    },
    manualUnconfirmation() {
      this.$store
        .dispatch('admin/candidates/manualUnconfirmation', this.$route.params.id)
        .then(() => {
          this.$store.dispatch('snackbarSuccess', 'Email Uncomfirmed')
          setTimeout(() => this.$emit('refresh'), 10000)
        })
        .catch(() => this.$store.dispatch('snackbarError', 'Unconfirmation failed'))
    },
  },
}
</script>
